
import React from 'react';

interface AppLoaderProps {
  isLoading: boolean;
}

const AppLoader: React.FC<AppLoaderProps> = ({ isLoading }) => {
  console.log('AppLoader: isLoading =', isLoading);
  
  if (!isLoading) {
    console.log('AppLoader: Hiding loader');
    return null;
  }

  return (
    <div className="fixed inset-0 bg-black flex items-center justify-center z-50">
      <div className="text-center">
        <img 
          src="/lovable-uploads/686591f9-3fb2-4efe-b292-80506550bc8a.png" 
          alt="Loena Luxury Suites" 
          width={200} 
          height={100}
          className="mx-auto mb-4"
          onError={(e) => {
            console.warn('Logo failed to load');
            e.currentTarget.style.display = 'none';
          }}
        />
        <div className="w-8 h-8 border-2 border-yellow-400 border-t-transparent rounded-full animate-spin mx-auto"></div>
        <p className="text-white mt-4">Loading...</p>
      </div>
    </div>
  );
};

export default AppLoader;
